"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _useParcelState3 = _interopRequireDefault(require("./useParcelState"));

var _useParcelSideEffect3 = _interopRequireDefault(require("./useParcelSideEffect"));

var _useParcelBuffer3 = _interopRequireDefault(require("./useParcelBuffer"));

// $FlowFixMe - useState is a named export of react
var _default = function _default(params) {
  var value = params.value,
      _params$updateValue = params.updateValue,
      updateValue = _params$updateValue === void 0 ? false : _params$updateValue,
      onChange = params.onChange,
      _params$onChangeUseRe = params.onChangeUseResult,
      onChangeUseResult = _params$onChangeUseRe === void 0 ? false : _params$onChangeUseRe,
      _params$buffer = params.buffer,
      buffer = _params$buffer === void 0 ? true : _params$buffer,
      _params$debounce = params.debounce,
      debounce = _params$debounce === void 0 ? 0 : _params$debounce,
      validation = params.validation,
      _params$beforeChange = params.beforeChange,
      beforeChange = _params$beforeChange === void 0 ? [] : _params$beforeChange;

  var _useState = (0, _react.useState)(function () {
    return validation && validation.length === 0 ? validation() : undefined;
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 1),
      validationFn = _useState2[0];

  beforeChange = [validationFn || validation].concat((0, _toConsumableArray2.default)(beforeChange)).filter(Boolean);

  var _useParcelState = (0, _useParcelState3.default)({
    value: value,
    updateValue: updateValue
  }),
      _useParcelState2 = (0, _slicedToArray2.default)(_useParcelState, 1),
      outerParcel = _useParcelState2[0];

  var _useParcelSideEffect = (0, _useParcelSideEffect3.default)({
    parcel: outerParcel,
    onChange: onChange,
    onChangeUseResult: onChangeUseResult
  }),
      _useParcelSideEffect2 = (0, _slicedToArray2.default)(_useParcelSideEffect, 2),
      sideEffectParcel = _useParcelSideEffect2[0],
      sideEffectControl = _useParcelSideEffect2[1];

  var _useParcelBuffer = (0, _useParcelBuffer3.default)({
    parcel: sideEffectParcel,
    buffer: buffer,
    debounce: debounce,
    beforeChange: beforeChange
  }),
      _useParcelBuffer2 = (0, _slicedToArray2.default)(_useParcelBuffer, 2),
      innerParcel = _useParcelBuffer2[0],
      innerParcelControl = _useParcelBuffer2[1];

  var control = (0, _objectSpread2.default)({}, sideEffectControl, innerParcelControl);
  return [innerParcel, control];
};

exports.default = _default;